import * as React from "react"
import * as ViewUtils from "../generated_views/view_utils"
import * as Immutable from "immutable"
import Select from 'react-select'


export type RadioCheckboxOptions = { value:string, label:string }
export function Radio(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  name: string,
  options:Immutable.List<RadioCheckboxOptions>,
  get_item:()=>string,
  set_item:(v:string)=>void) : JSX.Element {
    return mode == "view" ? 
        <div>{get_item()}</div>
      :
        <>
          {
            options.map(o => 
            <div className="form__group form__group--radio" key={o.value}>
              <input
                type="radio"
                name={name}
                id={name + " " + o.value}
                className="form__boolean form__radio"
                disabled={false}
                value={o.value}
                onChange={(s: React.FormEvent<HTMLInputElement>) =>
                  set_item(s.currentTarget.value)} 
                />
                <label htmlFor={name + " " + o.value} className="form__label">{o.label}</label>
            </div>)
          }
      </>
  }

export function Checkbox(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  name: string,
  options:Immutable.List<RadioCheckboxOptions>,
  get_item:()=>string,
  set_item:(v:string)=>void) : JSX.Element {
    return mode == "view" ? 
        <div>{get_item()}</div>
      :
        <>
          {
            options.map(o => 
            <div className="form__group form__group--checkbox" key={o.value}>
              <input
                type="checkbox"
                name={name}
                id={name + " " + o.value}
                className="form__boolean form__checkbox"
                disabled={false}
                value={o.value}
                onChange={(s: React.FormEvent<HTMLInputElement>) =>
                  set_item(s.currentTarget.value)} 
                />
                <label htmlFor={name + " " + o.value} className="form__label">{o.label}</label>
            </div>)
          }
        </>
  }

export function Dropdown(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  name: string,
  placeholder: string,
  classNamePrefix: string,
  options:Immutable.List<RadioCheckboxOptions>,
  get_item:()=>RadioCheckboxOptions,
  set_item:(v:RadioCheckboxOptions)=>void) : JSX.Element {
    return mode == "view" ? 
        <div>{get_item()}</div>
      :
        <>
          {
            <div className="mui-select form__select">
              <Select
                name={name}
                id={name}
                value={get_item()}
                options={options}
                onChange={(s) =>
                  set_item(s)}
                placeholder={placeholder}
                autoFocus
                classNamePrefix={classNamePrefix}
              />
            </div>
          }
      </>
  }

export function CheckboxOrRadio(
  selector_type: string,
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  name: string,
  options:Immutable.List<RadioCheckboxOptions>,
  get_item:()=>string,
  set_item:(v:string)=>void 
) : JSX.Element {
  if (selector_type == "radio") 
    return Radio(can_edit, mode, name, options, get_item, set_item ) 
  else
    return Checkbox(can_edit, mode, name, options, get_item, set_item ) 
}
